/**
  A reuseable component that can be used anywhere in the application 
  which takes the following params as props
 * @param { array of object containing labels & values } data - this will be used to render the tabs
 * @param { (value)=> void } onChange - will be used to set the active tab  
 * @param { any } value - active tab value  
 * @returns { node } - returns horizontal tabs
*/

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Tabs, Tab } from '@material-ui/core';
// import classNames from 'classnames';
import { isEmpty, isArray } from 'lodash';
import { keyEmptyCheck } from 'aurora-utils/utils';

import styles from './styles';

function ADGMHorizontalTabs({ classes, value, data, onChange }) {
  const handleTabChange = (_, newValue) => {
    onChange(newValue);
  };

  if (!isArray(data) || isEmpty(data)) return null;
  return (
    <Tabs className={classes.tabsHolder} value={value} onChange={handleTabChange}>
      {data?.map(tabData => (
        <Tab
          id={`tab-${tabData?.value}`}
          aria-controls={`tabpanel-${tabData?.value}`}
          className={classes.tab}
          label={keyEmptyCheck(tabData?.label)}
        />
      ))}
    </Tabs>
  );
}

ADGMHorizontalTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(ADGMHorizontalTabs);
